import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { client } from './data/client';
import './index.branch.html';
import { App } from './shell/App';
import * as Sentry from '@sentry/react';

const div = document.createElement('main');
div.className = 'root';
div.id = 'root';

if (window.document.body) {
  window.document.body.appendChild(div);
} else {
  console.error('Document body not found');
}

const root = createRoot(div);

Sentry.init({
  dsn: 'https://74ace4ab8ad021a468da133ab39898fa@o4509012338540544.ingest.us.sentry.io/4510144496533504',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: 0.5,
  replaysOnErrorSampleRate: 1.0, // 100% if we have an error
  environment: process.env.NODE_ENV || 'local'
});

root.render(
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </Sentry.ErrorBoundary>
);
